import {
  RefundStepperFormStep1,
  RefundStepperFormStep2,
} from '../components/Modals/PaymentRefundModalCreation/interfaces';
import { StrapiData, StrapiDataList, StrapiResponse } from './commons';
import { ReceiptResponse } from './receipts';

export interface PaymentResponse {
  data: {
    id: number;
    attributes: Payment;
  };
}

export interface Payment {
  amount: number;
  description: string;
  date: string;
  status: PaymentStatus;
  providerResponse: null | object;
  createdAt: string | null;
  updatedAt: string | null;
  method: PaymentMethod | null;
  receipt: StrapiResponse<ReceiptResponse>;
  refunds: StrapiDataList<Refund>;
}

export interface Refund {
  payment: StrapiData<Payment>;
  notes: string | null;
  date: string;
  amount: number;
  method: PaymentMethod;
  status: PaymentStatus;
}

export type RefundPaymentRequest = RefundStepperFormStep1 &
  RefundStepperFormStep2;

export enum InfoPaymentMethod {
  CASH_SECTION = 'CASH_SECTION',
  CASH_HEADQUARTER = 'CASH_HEADQUARTER',
  BANK_TRANSFER_SECTION = 'BANK_TRANSFER_SECTION',
  BANK_TRANSFER_HEADQUARTER = 'BANK_TRANSFER_HEADQUARTER',
  ATM = 'ATM',
  CARD = 'CARD',
}

export enum PaymentStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  AUTHORIZED = 'AUTHORIZED',
  CAPTURED = 'CAPTURED',
  VOIDED = 'VOIDED',
  PARTIAL = 'PARTIAL',
  CANCELED = 'CANCELED',
  REFUNDED = 'REFUNDED',
  REFUNDED_TOTAL = 'REFUNDED_TOTAL',
  REFUNDED_PARTIAL = 'REFUNDED_PARTIAL',
}

export enum PaymentMethod {
  PAYPAL = 'PAYPAL',
  CASH = 'CASH',
  BANK_CHECK = 'BANK_CHECK',
  BANK_TRANSFER_SECTION = 'BANK_TRANSFER_SECTION',
  BANK_TRANSFER_SITE = 'BANK_TRANSFER_SITE',
  BANCOMAT = 'BANCOMAT',
  PAYMENT_SLIP = 'PAYMENT_SLIP',
  AXERVE = 'AXERVE',
}

export const PaymentStatusLabel = {
  [PaymentStatus.COMPLETED]: 'Pagato',
  [PaymentStatus.AUTHORIZED]: 'Autorizzato',
  [PaymentStatus.CAPTURED]: 'Preso in carico',
  [PaymentStatus.VOIDED]: 'Vietato',
  [PaymentStatus.FAILED]: 'Pagamento fallito',
  [PaymentStatus.PENDING]: 'In attesa',
  [PaymentStatus.DRAFT]: 'Non pagato',
  [PaymentStatus.PARTIAL]: 'Parziale',
  [PaymentStatus.CANCELED]: 'Annullato',
  [PaymentStatus.REFUNDED]: 'Rimborsato',
  [PaymentStatus.REFUNDED_PARTIAL]: 'Rimborso parziale',
  [PaymentStatus.REFUNDED_TOTAL]: 'Rimborso totale',
};

export const PAYMENT_STATUSES_OPTIONS = [
  {
    id: PaymentStatus.COMPLETED,
    title: PaymentStatusLabel[PaymentStatus.COMPLETED],
  },
  { id: PaymentStatus.FAILED, title: PaymentStatusLabel[PaymentStatus.FAILED] },
  {
    id: PaymentStatus.PENDING,
    title: PaymentStatusLabel[PaymentStatus.PENDING],
  },
  { id: PaymentStatus.DRAFT, title: PaymentStatusLabel[PaymentStatus.DRAFT] },
  {
    id: PaymentStatus.PARTIAL,
    title: PaymentStatusLabel[PaymentStatus.PARTIAL],
  },
  {
    id: PaymentStatus.CANCELED,
    title: PaymentStatusLabel[PaymentStatus.CANCELED],
  },
  {
    id: PaymentStatus.REFUNDED,
    title: PaymentStatusLabel[PaymentStatus.REFUNDED],
  },
  {
    id: PaymentStatus.REFUNDED_PARTIAL,
    title: PaymentStatusLabel[PaymentStatus.REFUNDED_PARTIAL],
  },
  {
    id: PaymentStatus.REFUNDED_TOTAL,
    title: PaymentStatusLabel[PaymentStatus.REFUNDED_TOTAL],
  },
];

export const PAYMENT_STATUSES_OPTIONS_SOURCE = [
  {
    id: PaymentStatus.COMPLETED,
    attributes: {
      name: PAYMENT_STATUSES_OPTIONS.find(
        (elem) => elem.id === PaymentStatus.COMPLETED
      )?.title,
    },
  },
  {
    id: PaymentStatus.FAILED,
    attributes: {
      name: PAYMENT_STATUSES_OPTIONS.find(
        (elem) => elem.id === PaymentStatus.FAILED
      )?.title,
    },
  },
  {
    id: PaymentStatus.PENDING,
    attributes: {
      name: PAYMENT_STATUSES_OPTIONS.find(
        (elem) => elem.id === PaymentStatus.PENDING
      )?.title,
    },
  },
  {
    id: PaymentStatus.DRAFT,
    attributes: {
      name: PAYMENT_STATUSES_OPTIONS.find(
        (elem) => elem.id === PaymentStatus.DRAFT
      )?.title,
    },
  },
  {
    id: PaymentStatus.PARTIAL,
    attributes: {
      name: PAYMENT_STATUSES_OPTIONS.find(
        (elem) => elem.id === PaymentStatus.PARTIAL
      )?.title,
    },
  },
  {
    id: PaymentStatus.CANCELED,
    attributes: {
      name: PAYMENT_STATUSES_OPTIONS.find(
        (elem) => elem.id === PaymentStatus.CANCELED
      )?.title,
    },
  },
];
